import { render } from "./ChartViewTemplateSetting.vue?vue&type=template&id=d531e70c"
import script from "./ChartViewTemplateSetting.vue?vue&type=script&lang=js"
export * from "./ChartViewTemplateSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__